var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.537,
    height: 28.537,
    viewBox: "0 0 28.537 28.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-fb",
    d: "M1.574,0H26.962a1.575,1.575,0,0,1,1.575,1.574V26.962h0a1.575,1.575,0,0,1-1.575,1.575H1.575A1.575,1.575,0,0,1,0,26.963V1.575A1.575,1.575,0,0,1,1.574,0ZM19.7,17.5V28.537H15.244V17.5H11.537v-4.32h3.706V10c0-3.686,2.251-5.693,5.539-5.693a30.482,30.482,0,0,1,3.323.17V8.332H21.838c-1.789,0-2.136.85-2.136,2.1v2.751H23.98l-.557,4.32Z",
    fill: "#c4c4c4",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFb);
export default __webpack_public_path__ + "static/media/ico-fb.624becc71d2e2bb7f3220ff8924c003e.svg";
export { ForwardRef as ReactComponent };